var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPricing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 2C5.5 2 5.5 2.91421 5.5 3.5M5.5 3.5C5.5 5.0621 5.5 7.5 5.5 7.5M5.5 3.5C6.5 3.5 6.91405 3.70777 7.5 4L7 5M5.5 3.5C4 3.5 3 4.24971 3 5.5C3 6.75029 4.27465 7.1232 5.5 7.5M5.5 7.5C5.5 7.5 5.5 10.5474 5.5 12.5M5.5 7.5C6.37836 7.7701 8.5 8.5 8.5 10C8.5 11.8101 7 12.5 5.5 12.5M5.5 12.5C5.5 13.0858 5.5 13.4142 5.5 14M5.5 12.5C4.72038 12.518 3.55213 12.0507 3 11.5L3.5 10.5M9.5 14V12.5C11 12.5 12.5 11.8101 12.5 10C12.5 8.5 10.3784 7.7701 9.5 7.5M11 5L11.5 4L11.4955 3.99777C10.9119 3.70672 10.4974 3.5 9.5 3.5V2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricing);
export default __webpack_public_path__ + "static/media/Pricing.0e2598950b3f5a52676c108836c7ba78.svg";
export { ForwardRef as ReactComponent };